import { db, functions } from "./firebase";
import { doc, getDoc, setDoc, serverTimestamp, collection, query, where, getDocs } from "firebase/firestore";
import { httpsCallable } from 'firebase/functions';

export const checkUsernameAvailable = async (username) => {
  if (!username || username.length < 3) return false;

  try {
    const checkUsername = httpsCallable(functions, 'checkUsername');
    const result = await checkUsername({ username });
    return result.data.available;
  } catch (error) {
    console.error("Username check failed:", error);
    return false;
  }
};

const generateUsername = (user) => {
  if (user.email) {
    return user.email.split('@')[0].toLowerCase().replace(/[^a-z0-9_]/g, '');
  }
  if (user.displayName) {
    return user.displayName.toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '');
  }
  return 'user_' + user.uid.substring(0, 8);
};
export const saveUserToFirestore = async (user, customUsername = null) => {
  if (!user) return;
  const userRef = doc(db, "users", user.uid);
  try {
    const userSnap = await getDoc(userRef);
    if (userSnap.exists()) {
      const existingData = userSnap.data();
      const username = existingData.username || customUsername || generateUsername(user);
      await setDoc(userRef, {
        lastLogin: serverTimestamp(),
        email: user.email,
        displayName: existingData.displayName || user.displayName,
        photoURL: existingData.photoURL || user.photoURL,
        username: username,
        searchableUsername: username.toLowerCase(),
        searchableDisplayName: (existingData.displayName || user.displayName || '').toLowerCase(),
      }, { merge: true });
    } else {
      const username = customUsername || generateUsername(user);
      await setDoc(userRef, {
        uid: user.uid,
        displayName: user.displayName,
        email: user.email,
        photoURL: user.photoURL,
        studentStatus: "Student",
        totalStudyMinutes: 0,
        lastLogin: serverTimestamp(),
        createdAt: serverTimestamp(),
        username: username,
        searchableUsername: username.toLowerCase(),
        searchableDisplayName: (user.displayName || '').toLowerCase(),
        isPublic: true,
        followerCount: 0,
        followingCount: 0,
      });
    }
  } catch (e) {
    console.error("DB kayıt hatası:", e);
  }
};